"use strict";

var StoreId = /* @__PURE__ */(StoreId2 => {
  StoreId2["Br"] = "br";
  StoreId2["Mx"] = "mx";
  StoreId2["Ca"] = "ca";
  StoreId2["Cn"] = "cn";
  StoreId2["Eu"] = "eu";
  StoreId2["Jp"] = "jp";
  StoreId2["Me"] = "me";
  StoreId2["Uk"] = "uk";
  StoreId2["Us"] = "us";
  StoreId2["Za"] = "za";
  StoreId2["In"] = "in";
  StoreId2["Sg"] = "sg";
  StoreId2["Tw"] = "tw";
  StoreId2["Ph"] = "ph";
  return StoreId2;
})(StoreId || {});
var UnitSystem = /* @__PURE__ */(UnitSystem2 => {
  UnitSystem2["Imperial"] = "Imperial";
  UnitSystem2["Metric"] = "Metric";
  return UnitSystem2;
})(UnitSystem || {});
var Unit = /* @__PURE__ */(Unit2 => {
  Unit2["G"] = "g";
  Unit2["Kg"] = "kg";
  Unit2["Lb"] = "lb";
  Unit2["Oz"] = "oz";
  return Unit2;
})(Unit || {});
var Currency = /* @__PURE__ */(Currency2 => {
  Currency2["Aed"] = "AED";
  Currency2["Afn"] = "AFN";
  Currency2["All"] = "ALL";
  Currency2["Amd"] = "AMD";
  Currency2["Ang"] = "ANG";
  Currency2["Aoa"] = "AOA";
  Currency2["Ars"] = "ARS";
  Currency2["Aud"] = "AUD";
  Currency2["Awg"] = "AWG";
  Currency2["Azn"] = "AZN";
  Currency2["Bam"] = "BAM";
  Currency2["Bbd"] = "BBD";
  Currency2["Bdt"] = "BDT";
  Currency2["Bgn"] = "BGN";
  Currency2["Bhd"] = "BHD";
  Currency2["Bif"] = "BIF";
  Currency2["Bmd"] = "BMD";
  Currency2["Bnd"] = "BND";
  Currency2["Bob"] = "BOB";
  Currency2["Brl"] = "BRL";
  Currency2["Bsd"] = "BSD";
  Currency2["Btn"] = "BTN";
  Currency2["Bwp"] = "BWP";
  Currency2["Byr"] = "BYR";
  Currency2["Bzd"] = "BZD";
  Currency2["Cad"] = "CAD";
  Currency2["Cdf"] = "CDF";
  Currency2["Chf"] = "CHF";
  Currency2["Clp"] = "CLP";
  Currency2["Cny"] = "CNY";
  Currency2["Cop"] = "COP";
  Currency2["Crc"] = "CRC";
  Currency2["Cuc"] = "CUC";
  Currency2["Cup"] = "CUP";
  Currency2["Cve"] = "CVE";
  Currency2["Czk"] = "CZK";
  Currency2["Djf"] = "DJF";
  Currency2["Dkk"] = "DKK";
  Currency2["Dop"] = "DOP";
  Currency2["Dzd"] = "DZD";
  Currency2["Egp"] = "EGP";
  Currency2["Ern"] = "ERN";
  Currency2["Etb"] = "ETB";
  Currency2["Eur"] = "EUR";
  Currency2["Fjd"] = "FJD";
  Currency2["Fkp"] = "FKP";
  Currency2["Gbp"] = "GBP";
  Currency2["Gel"] = "GEL";
  Currency2["Ggp"] = "GGP";
  Currency2["Ghs"] = "GHS";
  Currency2["Gip"] = "GIP";
  Currency2["Gmd"] = "GMD";
  Currency2["Gnf"] = "GNF";
  Currency2["Gtq"] = "GTQ";
  Currency2["Gyd"] = "GYD";
  Currency2["Hkd"] = "HKD";
  Currency2["Hnl"] = "HNL";
  Currency2["Hrk"] = "HRK";
  Currency2["Htg"] = "HTG";
  Currency2["Huf"] = "HUF";
  Currency2["Idr"] = "IDR";
  Currency2["Ils"] = "ILS";
  Currency2["Imp"] = "IMP";
  Currency2["Inr"] = "INR";
  Currency2["Iqd"] = "IQD";
  Currency2["Irr"] = "IRR";
  Currency2["Isk"] = "ISK";
  Currency2["Jep"] = "JEP";
  Currency2["Jmd"] = "JMD";
  Currency2["Jod"] = "JOD";
  Currency2["Jpy"] = "JPY";
  Currency2["Kes"] = "KES";
  Currency2["Kgs"] = "KGS";
  Currency2["Khr"] = "KHR";
  Currency2["Kmf"] = "KMF";
  Currency2["Kpw"] = "KPW";
  Currency2["Krw"] = "KRW";
  Currency2["Kwd"] = "KWD";
  Currency2["Kyd"] = "KYD";
  Currency2["Kzt"] = "KZT";
  Currency2["Lak"] = "LAK";
  Currency2["Lbp"] = "LBP";
  Currency2["Lkr"] = "LKR";
  Currency2["Lrd"] = "LRD";
  Currency2["Lsl"] = "LSL";
  Currency2["Lyd"] = "LYD";
  Currency2["Mad"] = "MAD";
  Currency2["Mdl"] = "MDL";
  Currency2["Mga"] = "MGA";
  Currency2["Mkd"] = "MKD";
  Currency2["Mmk"] = "MMK";
  Currency2["Mnt"] = "MNT";
  Currency2["Mop"] = "MOP";
  Currency2["Mro"] = "MRO";
  Currency2["Mur"] = "MUR";
  Currency2["Mvr"] = "MVR";
  Currency2["Mwk"] = "MWK";
  Currency2["Mxn"] = "MXN";
  Currency2["Myr"] = "MYR";
  Currency2["Mzn"] = "MZN";
  Currency2["Nad"] = "NAD";
  Currency2["Ngn"] = "NGN";
  Currency2["Nio"] = "NIO";
  Currency2["Nok"] = "NOK";
  Currency2["Npr"] = "NPR";
  Currency2["Nzd"] = "NZD";
  Currency2["Omr"] = "OMR";
  Currency2["Pab"] = "PAB";
  Currency2["Pen"] = "PEN";
  Currency2["Pgk"] = "PGK";
  Currency2["Php"] = "PHP";
  Currency2["Pkr"] = "PKR";
  Currency2["Pln"] = "PLN";
  Currency2["Pyg"] = "PYG";
  Currency2["Qar"] = "QAR";
  Currency2["Ron"] = "RON";
  Currency2["Rsd"] = "RSD";
  Currency2["Rub"] = "RUB";
  Currency2["Rwf"] = "RWF";
  Currency2["Sar"] = "SAR";
  Currency2["Sbd"] = "SBD";
  Currency2["Scr"] = "SCR";
  Currency2["Sdg"] = "SDG";
  Currency2["Sek"] = "SEK";
  Currency2["Sgd"] = "SGD";
  Currency2["Shp"] = "SHP";
  Currency2["Sll"] = "SLL";
  Currency2["Sos"] = "SOS";
  Currency2["Spl"] = "SPL";
  Currency2["Srd"] = "SRD";
  Currency2["Std"] = "STD";
  Currency2["Svc"] = "SVC";
  Currency2["Syp"] = "SYP";
  Currency2["Szl"] = "SZL";
  Currency2["Thb"] = "THB";
  Currency2["Tjs"] = "TJS";
  Currency2["Tmt"] = "TMT";
  Currency2["Tnd"] = "TND";
  Currency2["Top"] = "TOP";
  Currency2["Try"] = "TRY";
  Currency2["Ttd"] = "TTD";
  Currency2["Tvd"] = "TVD";
  Currency2["Twd"] = "TWD";
  Currency2["Tzs"] = "TZS";
  Currency2["Uah"] = "UAH";
  Currency2["Ugx"] = "UGX";
  Currency2["Usd"] = "USD";
  Currency2["Uyu"] = "UYU";
  Currency2["Uzs"] = "UZS";
  Currency2["Vef"] = "VEF";
  Currency2["Vnd"] = "VND";
  Currency2["Vuv"] = "VUV";
  Currency2["Wst"] = "WST";
  Currency2["Xaf"] = "XAF";
  Currency2["Xcd"] = "XCD";
  Currency2["Xdr"] = "XDR";
  Currency2["Xof"] = "XOF";
  Currency2["Xpf"] = "XPF";
  Currency2["Yer"] = "YER";
  Currency2["Zar"] = "ZAR";
  Currency2["Zmw"] = "ZMW";
  Currency2["Zwd"] = "ZWD";
  return Currency2;
})(Currency || {});
var CountryCode = /* @__PURE__ */(CountryCode2 => {
  CountryCode2["Ad"] = "AD";
  CountryCode2["Ae"] = "AE";
  CountryCode2["Af"] = "AF";
  CountryCode2["Ag"] = "AG";
  CountryCode2["Ai"] = "AI";
  CountryCode2["Al"] = "AL";
  CountryCode2["Am"] = "AM";
  CountryCode2["An"] = "AN";
  CountryCode2["Ao"] = "AO";
  CountryCode2["Aq"] = "AQ";
  CountryCode2["Ar"] = "AR";
  CountryCode2["As"] = "AS";
  CountryCode2["At"] = "AT";
  CountryCode2["Au"] = "AU";
  CountryCode2["Aw"] = "AW";
  CountryCode2["Ax"] = "AX";
  CountryCode2["Az"] = "AZ";
  CountryCode2["Ba"] = "BA";
  CountryCode2["Bb"] = "BB";
  CountryCode2["Bd"] = "BD";
  CountryCode2["Be"] = "BE";
  CountryCode2["Bf"] = "BF";
  CountryCode2["Bg"] = "BG";
  CountryCode2["Bh"] = "BH";
  CountryCode2["Bi"] = "BI";
  CountryCode2["Bj"] = "BJ";
  CountryCode2["Bm"] = "BM";
  CountryCode2["Bn"] = "BN";
  CountryCode2["Bo"] = "BO";
  CountryCode2["Br"] = "BR";
  CountryCode2["Bs"] = "BS";
  CountryCode2["Bt"] = "BT";
  CountryCode2["Bv"] = "BV";
  CountryCode2["Bw"] = "BW";
  CountryCode2["By"] = "BY";
  CountryCode2["Bz"] = "BZ";
  CountryCode2["Ca"] = "CA";
  CountryCode2["Cc"] = "CC";
  CountryCode2["Cd"] = "CD";
  CountryCode2["Cf"] = "CF";
  CountryCode2["Cg"] = "CG";
  CountryCode2["Ch"] = "CH";
  CountryCode2["Ci"] = "CI";
  CountryCode2["Ck"] = "CK";
  CountryCode2["Cl"] = "CL";
  CountryCode2["Cm"] = "CM";
  CountryCode2["Cn"] = "CN";
  CountryCode2["Co"] = "CO";
  CountryCode2["Cr"] = "CR";
  CountryCode2["Cu"] = "CU";
  CountryCode2["Cv"] = "CV";
  CountryCode2["Cx"] = "CX";
  CountryCode2["Cy"] = "CY";
  CountryCode2["Cz"] = "CZ";
  CountryCode2["De"] = "DE";
  CountryCode2["Dj"] = "DJ";
  CountryCode2["Dk"] = "DK";
  CountryCode2["Dm"] = "DM";
  CountryCode2["Do"] = "DO";
  CountryCode2["Dz"] = "DZ";
  CountryCode2["Ec"] = "EC";
  CountryCode2["Ee"] = "EE";
  CountryCode2["Eg"] = "EG";
  CountryCode2["Eh"] = "EH";
  CountryCode2["Er"] = "ER";
  CountryCode2["Es"] = "ES";
  CountryCode2["Et"] = "ET";
  CountryCode2["Fi"] = "FI";
  CountryCode2["Fj"] = "FJ";
  CountryCode2["Fk"] = "FK";
  CountryCode2["Fm"] = "FM";
  CountryCode2["Fo"] = "FO";
  CountryCode2["Fr"] = "FR";
  CountryCode2["Ga"] = "GA";
  CountryCode2["Gb"] = "GB";
  CountryCode2["Gd"] = "GD";
  CountryCode2["Ge"] = "GE";
  CountryCode2["Gf"] = "GF";
  CountryCode2["Gg"] = "GG";
  CountryCode2["Gh"] = "GH";
  CountryCode2["Gi"] = "GI";
  CountryCode2["Gl"] = "GL";
  CountryCode2["Gm"] = "GM";
  CountryCode2["Gn"] = "GN";
  CountryCode2["Gp"] = "GP";
  CountryCode2["Gq"] = "GQ";
  CountryCode2["Gr"] = "GR";
  CountryCode2["Gs"] = "GS";
  CountryCode2["Gt"] = "GT";
  CountryCode2["Gu"] = "GU";
  CountryCode2["Gw"] = "GW";
  CountryCode2["Gy"] = "GY";
  CountryCode2["Hk"] = "HK";
  CountryCode2["Hm"] = "HM";
  CountryCode2["Hn"] = "HN";
  CountryCode2["Hr"] = "HR";
  CountryCode2["Ht"] = "HT";
  CountryCode2["Hu"] = "HU";
  CountryCode2["Id"] = "ID";
  CountryCode2["Ie"] = "IE";
  CountryCode2["Il"] = "IL";
  CountryCode2["Im"] = "IM";
  CountryCode2["In"] = "IN";
  CountryCode2["Io"] = "IO";
  CountryCode2["Iq"] = "IQ";
  CountryCode2["Ir"] = "IR";
  CountryCode2["Is"] = "IS";
  CountryCode2["It"] = "IT";
  CountryCode2["Je"] = "JE";
  CountryCode2["Jm"] = "JM";
  CountryCode2["Jo"] = "JO";
  CountryCode2["Jp"] = "JP";
  CountryCode2["Ke"] = "KE";
  CountryCode2["Kg"] = "KG";
  CountryCode2["Kh"] = "KH";
  CountryCode2["Ki"] = "KI";
  CountryCode2["Km"] = "KM";
  CountryCode2["Kn"] = "KN";
  CountryCode2["Kp"] = "KP";
  CountryCode2["Kr"] = "KR";
  CountryCode2["Kw"] = "KW";
  CountryCode2["Ky"] = "KY";
  CountryCode2["Kz"] = "KZ";
  CountryCode2["La"] = "LA";
  CountryCode2["Lb"] = "LB";
  CountryCode2["Lc"] = "LC";
  CountryCode2["Li"] = "LI";
  CountryCode2["Lk"] = "LK";
  CountryCode2["Lr"] = "LR";
  CountryCode2["Ls"] = "LS";
  CountryCode2["Lt"] = "LT";
  CountryCode2["Lu"] = "LU";
  CountryCode2["Lv"] = "LV";
  CountryCode2["Ly"] = "LY";
  CountryCode2["Ma"] = "MA";
  CountryCode2["Mc"] = "MC";
  CountryCode2["Md"] = "MD";
  CountryCode2["Me"] = "ME";
  CountryCode2["Mg"] = "MG";
  CountryCode2["Mh"] = "MH";
  CountryCode2["Mk"] = "MK";
  CountryCode2["Ml"] = "ML";
  CountryCode2["Mm"] = "MM";
  CountryCode2["Mn"] = "MN";
  CountryCode2["Mo"] = "MO";
  CountryCode2["Mp"] = "MP";
  CountryCode2["Mq"] = "MQ";
  CountryCode2["Mr"] = "MR";
  CountryCode2["Ms"] = "MS";
  CountryCode2["Mt"] = "MT";
  CountryCode2["Mu"] = "MU";
  CountryCode2["Mv"] = "MV";
  CountryCode2["Mw"] = "MW";
  CountryCode2["Mx"] = "MX";
  CountryCode2["My"] = "MY";
  CountryCode2["Mz"] = "MZ";
  CountryCode2["Na"] = "NA";
  CountryCode2["Nc"] = "NC";
  CountryCode2["Ne"] = "NE";
  CountryCode2["Nf"] = "NF";
  CountryCode2["Ng"] = "NG";
  CountryCode2["Ni"] = "NI";
  CountryCode2["Nl"] = "NL";
  CountryCode2["No"] = "NO";
  CountryCode2["Np"] = "NP";
  CountryCode2["Nr"] = "NR";
  CountryCode2["Nu"] = "NU";
  CountryCode2["Nz"] = "NZ";
  CountryCode2["Om"] = "OM";
  CountryCode2["Pa"] = "PA";
  CountryCode2["Pe"] = "PE";
  CountryCode2["Pf"] = "PF";
  CountryCode2["Pg"] = "PG";
  CountryCode2["Ph"] = "PH";
  CountryCode2["Pk"] = "PK";
  CountryCode2["Pl"] = "PL";
  CountryCode2["Pm"] = "PM";
  CountryCode2["Pn"] = "PN";
  CountryCode2["Pr"] = "PR";
  CountryCode2["Ps"] = "PS";
  CountryCode2["Pt"] = "PT";
  CountryCode2["Pw"] = "PW";
  CountryCode2["Py"] = "PY";
  CountryCode2["Qa"] = "QA";
  CountryCode2["Re"] = "RE";
  CountryCode2["Ro"] = "RO";
  CountryCode2["Rs"] = "RS";
  CountryCode2["Ru"] = "RU";
  CountryCode2["Rw"] = "RW";
  CountryCode2["Sa"] = "SA";
  CountryCode2["Sb"] = "SB";
  CountryCode2["Sc"] = "SC";
  CountryCode2["Sd"] = "SD";
  CountryCode2["Se"] = "SE";
  CountryCode2["Sg"] = "SG";
  CountryCode2["Sh"] = "SH";
  CountryCode2["Si"] = "SI";
  CountryCode2["Sj"] = "SJ";
  CountryCode2["Sk"] = "SK";
  CountryCode2["Sl"] = "SL";
  CountryCode2["Sm"] = "SM";
  CountryCode2["Sn"] = "SN";
  CountryCode2["So"] = "SO";
  CountryCode2["Sr"] = "SR";
  CountryCode2["St"] = "ST";
  CountryCode2["Sv"] = "SV";
  CountryCode2["Sy"] = "SY";
  CountryCode2["Sz"] = "SZ";
  CountryCode2["Tc"] = "TC";
  CountryCode2["Td"] = "TD";
  CountryCode2["Tf"] = "TF";
  CountryCode2["Tg"] = "TG";
  CountryCode2["Th"] = "TH";
  CountryCode2["Tj"] = "TJ";
  CountryCode2["Tk"] = "TK";
  CountryCode2["Tl"] = "TL";
  CountryCode2["Tm"] = "TM";
  CountryCode2["Tn"] = "TN";
  CountryCode2["To"] = "TO";
  CountryCode2["Tr"] = "TR";
  CountryCode2["Tt"] = "TT";
  CountryCode2["Tv"] = "TV";
  CountryCode2["Tw"] = "TW";
  CountryCode2["Tz"] = "TZ";
  CountryCode2["Ua"] = "UA";
  CountryCode2["Ug"] = "UG";
  CountryCode2["Um"] = "UM";
  CountryCode2["Us"] = "US";
  CountryCode2["Uy"] = "UY";
  CountryCode2["Uz"] = "UZ";
  CountryCode2["Va"] = "VA";
  CountryCode2["Vc"] = "VC";
  CountryCode2["Ve"] = "VE";
  CountryCode2["Vg"] = "VG";
  CountryCode2["Vi"] = "VI";
  CountryCode2["Vn"] = "VN";
  CountryCode2["Vu"] = "VU";
  CountryCode2["Wf"] = "WF";
  CountryCode2["Ws"] = "WS";
  CountryCode2["Ye"] = "YE";
  CountryCode2["Yt"] = "YT";
  CountryCode2["Za"] = "ZA";
  CountryCode2["Zm"] = "ZM";
  CountryCode2["Zw"] = "ZW";
  return CountryCode2;
})(CountryCode || {});
var UserAssignedCountryCode = /* @__PURE__ */(UserAssignedCountryCode2 => {
  UserAssignedCountryCode2["Xi"] = "XI";
  UserAssignedCountryCode2["El"] = "EL";
  UserAssignedCountryCode2["Fr"] = "FR";
  return UserAssignedCountryCode2;
})(UserAssignedCountryCode || {});
var AddressType = /* @__PURE__ */(AddressType2 => {
  AddressType2["Business"] = "Business";
  AddressType2["Residential"] = "Residential";
  return AddressType2;
})(AddressType || {});
var ValidateTaxStatus = /* @__PURE__ */(ValidateTaxStatus2 => {
  ValidateTaxStatus2["Invalid"] = "Invalid";
  ValidateTaxStatus2["Unavailable"] = "Unavailable";
  ValidateTaxStatus2["Valid"] = "Valid";
  ValidateTaxStatus2["NotValidated"] = "NotValidated";
  return ValidateTaxStatus2;
})(ValidateTaxStatus || {});
var ProductLine = /* @__PURE__ */(ProductLine2 => {
  ProductLine2["Uisp"] = "Uisp";
  ProductLine2["Unifi"] = "Unifi";
  ProductLine2["Amplifi"] = "Amplifi";
  return ProductLine2;
})(ProductLine || {});
var PaymentProvider = /* @__PURE__ */(PaymentProvider2 => {
  PaymentProvider2["Alipay"] = "Alipay";
  PaymentProvider2["Hitrust"] = "Hitrust";
  PaymentProvider2["PagBrasil"] = "PagBrasil";
  PaymentProvider2["Paypal"] = "Paypal";
  PaymentProvider2["Paystack"] = "Paystack";
  PaymentProvider2["Razorpay"] = "Razorpay";
  PaymentProvider2["StoreManual"] = "StoreManual";
  PaymentProvider2["Stripe"] = "Stripe";
  return PaymentProvider2;
})(PaymentProvider || {});
export { AddressType, CountryCode, Currency, PaymentProvider, ProductLine, StoreId, Unit, UnitSystem, UserAssignedCountryCode, ValidateTaxStatus };
//# sourceMappingURL=generated.mjs.map
